import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { DEFAULT_WIDTH } from "../../helpers/constant";

const Footer = () => {
  const mdTextColor = useColorModeValue("gray.600", "gray.400");
  const baseTextColor = useColorModeValue("gray.900", "gray.400");

  return (
    <Box
      w={DEFAULT_WIDTH}
      mx="auto"
      h="full"
      color={{ base: baseTextColor, md: mdTextColor }}
      my={{ base: "24px", md: "32px" }}
      display="flex"
      flexDir="column"
      justifyContent="flex-end"
      alignItems="center"
    >
      <Text m={0} fontSize="14px" textAlign="center">
        Copyright {new Date().getFullYear()} MSA - Famille en Jésus-Christ
      </Text>
    </Box>
  );
};

export default Footer;
